import {Writeable} from '../../lib/helpers';
import {
  ContentTreeDto,
  X1Language,
  X2AgeCategory,
  X3Level,
  X4Unit,
  X5Lesson
} from '../models/content';
import {ContentLookup} from '../models/content-lookup';

function cloneArray<T>(array: readonly T[] | null, clone: (t: T) => T): T[] {
  if (array === null)
    return [];
  return array.map(x => clone(x));
}

export function prepareContentLookup(dto: ContentTreeDto): ContentLookup {
  let x1ById: { [index: number]: X1Language } = {};
  let x2ById: { [index: number]: X2AgeCategory } = {};
  let x3ById: { [index: number]: X3Level } = {};
  let x4ById: { [index: number]: X4Unit } = {};
  let x5ById: { [index: number]: X5Lesson } = {};

  function cloneX5(parent: X4Unit, lesson: X5Lesson): X5Lesson {
    let result: X5Lesson = {
      Id: lesson.Id,
      UnitId: lesson.UnitId,
      Unit: parent,
      Index: lesson.Index,
      LessonType: lesson.LessonType,
      Name: lesson.Name,
      Pages: null,
      Snapshots: null
    };
    x5ById[lesson.Id] = result;

    return result;
  }

  function cloneX4(parent: X3Level, unit: X4Unit): X4Unit {
    let result: Writeable<X4Unit> = {
      LevelId: unit.LevelId,
      Level: parent,
      Id: unit.Id,
      Index: unit.Index,
      Name: unit.Name,
      Lessons: null
    };
    result.Lessons = cloneArray(unit.Lessons, (x) => cloneX5(result, x));
    x4ById[unit.Id] = result;
    return result;
  }

  function cloneX3(parent: X2AgeCategory, level: X3Level): X3Level {
    let result: Writeable<X3Level> = {
      AgeCategoryId: level.AgeCategoryId,
      AgeCategory: parent,
      Id: level.Id,
      Index: level.Index,
      Name: level.Name,
      Units: null
    };
    result.Units = cloneArray(level.Units, (x) => cloneX4(result, x));
    x3ById[level.Id] = result;
    return result;
  }

  function cloneX2(parent: X1Language, ageCategory: X2AgeCategory): X2AgeCategory {
    let result: Writeable<X2AgeCategory> = {
      LanguageId: ageCategory.LanguageId,
      Language: parent,
      Id: ageCategory.Id,
      Index: ageCategory.Index,
      Name: ageCategory.Name,
      Levels: null
    };
    result.Levels = cloneArray(ageCategory.Levels, (x) => cloneX3(result, x));
    x2ById[ageCategory.Id] = result;
    return result;
  }

  function cloneX1(language: X1Language): X1Language {
    let result: Writeable<X1Language> = {
      Id: language.Id,
      Index: language.Index,
      Name: language.Name,
      AgeCategories: null
    };
    result.AgeCategories = cloneArray(language.AgeCategories, (x) => cloneX2(result, x));
    x1ById[language.Id] = result;
    return result;
  }

  let languages: X1Language[] = cloneArray(dto.Languages, cloneX1);

  return {
    Languages: languages,
    X1LanguageById: x1ById,
    X2AgeCategoryById: x2ById,
    X3LevelById: x3ById,
    X4UnitById: x4ById,
    X5LessonById: x5ById
  };
}
